import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'

const Accelerate = () => {
    return (
        <>
            {/* Accelerate cloud */}
            <section className="accelerate-cloud-three">
                <div className="container">
                    <div className="shapes-three-left">
                        <ImageWithBasePath
                            className="accelerate-three"
                            src="assets/img/shapes/shape-8.png"
                            alt="Img"
                        />
                        <ImageWithBasePath
                            className="accelerate-five"
                            src="assets/img/shapes/shape-9.png"
                            alt="Img"
                        />
                    </div>
                    <div className="section-header-title d-none" data-aos="fade-up">
                        <div className="row align-items-center d-flex justify-content-between">
                            <div className="col-lg-5 col-md-12">
                                <div className="home-five-head mb-4">
                                    <h2 className="text-white">Accelerate Cloud Success </h2>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <p className="text-white ms-lg-5 mb-4">
                                    96% of eLearning for Business customers see improved results
                                    within six months. Whether you’re a team of 10 or 10,000, faster
                                    cloud fluency starts here.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Award Winning */}
                    <div className="award-one">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/feature/feature-8.jpg"
                                        alt="img"
                                    />
                                    <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-9.jpg"
                                            alt="img"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/award.svg" alt="certified" />
                                    </div>
                                    <h2 className="text-warning my-4">
                                        Award Winning Course Management
                                    </h2>
                                    <p className="text-white mb-4">
                                        An award-winning course management system (CMS) or program is
                                        typically recognized for its exceptional quality, innovation,
                                        and effectiveness in helping both instructors and students
                                        succeed.
                                    </p>
                                    {/* List */}
                                    <ul className="list-unstyled text-white mb-5">
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-warning fs-24 me-2" />
                                            Interactive Tools for Engagement
                                        </li>
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-warning fs-24 me-2" />
                                            Customizable Course Creation
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-warning fs-24 me-2" />
                                            Robust Analytics and Reporting
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-warning fs-24 me-2" />
                                            Collaborative and Peer-to-Peer Learning
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-warning fs-24 me-2" />
                                            The Most World Class Instructors
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Award Winning */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h2 className="text-skyblue my-4">
                                        Learn anything from anywhere anytime
                                    </h2>
                                    <p className="text-white mb-4">
                                        In today’s fast-paced, digital world, the ability to learn
                                        anything, from anywhere, and at any time is more accessible than
                                        ever. Whether you are looking to expand your knowledge, gain new
                                        skills.
                                    </p>
                                    {/* List */}
                                    <ul className="list-unstyled text-white mb-5">
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-skyblue fs-24 me-2" />
                                            Interactive Tools for Engagement
                                        </li>
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-skyblue fs-24 me-2" />
                                            Customizable Course Creation
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-skyblue fs-24 me-2" />
                                            Robust Analytics and Reporting
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-skyblue fs-24 me-2" />
                                            Collaborative and Peer-to-Peer Learning
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-skyblue fs-24 me-2" />
                                            The Most World Class Instructors
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/feature/feature-12.jpg"
                                        alt="img"
                                    />
                                    <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/feature/feature-5.jpg"
                                        alt="img"
                                    />
                                    <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h2 className="text-success my-4">
                                        Certification for solid development of your Career
                                    </h2>
                                    <p className="text-white mb-4">
                                        Certifications are a powerful way to enhance your skills, build
                                        credibility, and boost your career growth. In today’s
                                        competitive job market, a professional certification.
                                    </p>
                                    {/* List */}
                                    <ul className="list-unstyled text-white mb-5">
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                            Demonstrates Expertise
                                        </li>
                                        <li className="d-flex mb-3">
                                            <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                            Boosts Your Credibility
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                            Improves Job Security
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                            Facilitates Career Advancement
                                        </li>
                                        <li className="d-flex mb-3" data-aos="fade-up">
                                            <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                            Fosters Personal Growth
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                </div>
            </section>
            {/* Accelerate cloud */}
        </>

    )
}

export default Accelerate
